module.exports = __webpack_public_path__ + "static/img/life-style6.79007c4f.png";